import React from 'react'

const ContactItem = ({value: {title, subTitle, icon}}) => {
  return (
    <div className="contact__information">
        <i className={icon}></i>

        <div>
            <h3 className='contact__title'>{title}</h3>
            <span className='contact__subtitle'>{subTitle}</span>
        </div>
    </div>
  )
}

export default ContactItem